import { baseApi } from "./baseApi";

const HOSPITAL_URL = "/doc-aide-svc/hospitals";

export const hospitalApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getHospitalDetails: builder.query({
      query: (hospitalId) =>
        `${HOSPITAL_URL}/hospitalss?HospitalID=${hospitalId}`,
      transformResponse: (response) => response?.Hospitalss,
    }),
    getHospitalPhysiciansList: builder.query({
      query: () =>
        `/doc-aide-svc/physicians/get_physicians_by_hospital_id?HospitalID=1`,
    }),
    getHospitalDashboardDetails: builder.query({
      query: () => `/doc-aide-svc/hospitals?HospitalID=1`,
    }),
    /* getHospitalPatientsList: builder.query({
        query: (hospitalID) =>
          `/doc-aide-svc/physicians/get_physicians_by_hospital_id?HospitalID=${hospitalID}`, //change endpoint
      }), */
  }),
  overrideExisting: false,
});

export const {
  useGetHospitalDetailsQuery,
  useGetHospitalPhysiciansListQuery,
  useGetHospitalDashboardDetailsQuery,
} = hospitalApi;
